<svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.5 68.5L52.5 68.5C61.3366 68.5 68.5 61.3366 68.5 52.5L68.5 2.49999" stroke="white" stroke-width="5" stroke-linecap="square"/>
</svg>
